<template>
  <v-snackbar v-model="snackbar" right :timeout="timeout" top :color="type">
    {{ text }}
    <v-btn color="white" dark flat @click="snackbar = false">Close</v-btn>
  </v-snackbar>
</template>

<script>
export default {
  data() {
    return {
      snackbar: false,
      text: "Hi there.",
      type: "info"
    };
  },
  computed: {
    timeout() {
      // If there is an error, do not hide the snackbar
      return this.type == "error" ? 0 : 6000;
    }
  },
  methods: {
    open(alertType, alertMessage) {
      this.type = alertType;
      this.text = alertMessage;
      this.snackbar = true;
    }
  }
};
</script>
